import '.h0{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.h1{padding-left:1.5rem;}.ssr-plugin'
import '.h2{margin:1rem 0;}.ssr-plugin'
import '.h3{color:var(--gray-700);}.ssr-plugin'
import '.h4{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="h0 h1 h2 h3 h4"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
